import React, { useContext } from "react";
import BaseMenuPrincipal from "../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal";
import { InfoLateralEntradasPt2 } from "../../../componentes/InfoLateralEntradasComponent/InfoLateralEntradasComponent";
import {AdicionandoDados} from "../../../context/AdicionandoDados";

const Entradas = () => {
    const { estaAdicionandoDados, setEstaAdicionandoDados } = useContext(AdicionandoDados);

    return (
        <>
            <BaseMenuPrincipal
                InfoLateral={<InfoLateralEntradasPt2 />}
            />
            
            
        </>
    );
};

export default Entradas;
